module.exports = __webpack_public_path__ + "b6a190717fd41b5e489a5df7badbb5f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-1.png
// module id = 2068
// module chunks = 0